const configDeclaration = {
    board: {
        listLayout: 'DeclarationListDefaultLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getDeclaration',
        listApiParamSet: {
            ty: 'post',
            ip:1
        },
        deleteFunc: 'deleteDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        penaltyFunc:'penaltyDeclaration',
        keyName: 'bb_idx',
        detailKey:''

    },
    reply: {
        listLayout: 'DeclarationListReplyLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getDeclaration',
        listApiParamSet: {
            ty: 'comment',
            ip:1
        },
        deleteFunc: 'deleteDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        penaltyFunc:'penaltyDeclaration',
        keyName: 'bb_idx',
        detailKey:''
    },
    content: {
        listLayout: 'DeclarationListConentLayout',
        filterLayout: 'DeclarationFilterConentLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getContentDeclaration',
        listApiParamSet: {
            ip:1
        },
        deleteFunc: 'deleteContentDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'ccb_idx',
        detailKey:''
    },
    message: {
        listLayout: 'DeclarationListDefaultLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: '',
        listApiParamSet: {},
    },
    chat: {
        listLayout: 'DeclarationListChatLayout',
        filterLayout: 'DeclarationFilterOpenChatLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getChatReport',
        listApiParamSet: {ip:1},
        deleteFunc: 'deleteChatReport',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'rc_idx',
        detailKey:'',
        penaltyFunc:'penaltyDeclaration',
    },
    openChat: {
        listLayout: 'DeclarationListOpenChatLayout',
        filterLayout: 'DeclarationFilterOpenChatLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getOpenChatReport',
        listApiParamSet: {ip:1},
        deleteFunc: 'deleteOpenChatReport',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'ro_idx',
        detailKey:''
    },
    chatDetail: {
        writeLayout : 'declarationWriteChatLayout',
        getFunc : 'getChatReport',
        deleteFunc : 'deleteChatReport',
        keyName : 'rc_idx',
    },
    openChatDetail: {
        writeLayout : 'declarationWriteDefaultLayout',
        getFunc : 'getOpenChatReport',
        deleteFunc : 'deleteOpenChatReport',
        keyName : 'ro_idx',
    },
    korean: {
        listLayout: 'DeclarationListDefaultLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getKoreanDeclaration',
        listApiParamSet: {
            ty: 'post',
            ip:1
        },
        deleteFunc: 'deleteKoreanDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'bb_idx',
        penaltyFunc:'penaltyKoreanDeclaration',
        detailKey:''

    },
    koreanComment: {
        listLayout: 'DeclarationListReplyLayout',
        filterLayout: 'DeclarationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',

        getFunc: 'getKoreanDeclaration',
        listApiParamSet: {
            ty: 'comment',
            ip:1
        },
        deleteFunc: 'deleteKoreanDeclaration',
        deleteApiParamsSet: {
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
        deleteErrorTypes:{},
        keyName: 'bb_idx',
        penaltyFunc:'penaltyKoreanDeclaration',
        detailKey:''
    },
}

export default {
    methods: {
        returnDeclarationConfig(type) {
            return configDeclaration[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        wni: {
            type: 'query',
            classname: 'searchInput',
        },
        wmid: {
            type: 'query',
            classname: 'searchInput',
        },
        wid: {
            type: 'query',
            classname: 'searchInput',
        },
        dni:{
            type: 'query',
            classname: 'searchInput',
        },
        did:{
            type: 'query',
            classname: 'searchInput',
        },
        re_id:{
            type: 'query',
            classname: 'searchInput',
        },
        re_ni:{
            type: 'query',
            classname: 'searchInput',
        }
    }
}
